import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { dateTimeFormat } from 'constants/formats';
import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';

const CertificationViewHeader: FC = () => {
  const { t } = useTranslate();
  const { data } = useCommunicationDetailsPage();
  const { communication } = data;
  const certificateId = communication?.certificate?.id || '00746F5K28';

  return (
    <div className="cv-header-wrapper">
      <div className="cv-header">
        <div className="cv-header-left">
          <div className="cv-title-row">
            <h1 className="cv-title mb-0">{t('Certificate')}</h1>
            <span className="cv-id-badge">#{certificateId}</span>
          </div>
          <p className="cv-subtitle">{t('SttokCertifies')}:</p>
        </div>
        <div className="cv-shield-icon">
          <em className="icon ni ni-shield-check-fill" />
        </div>
      </div>

      <div className="cv-legal-notice">{t('CertificationMessage')}</div>

      <div className="cv-meta-row">
        <span>
          <strong>{t('GeneratedCertificate')}:</strong>{' '}
          {format(new Date(), dateTimeFormat)}
        </span>
        <span>
          <strong>{t('Certificate')} Nº:</strong> #{certificateId}
        </span>
      </div>
    </div>
  );
};

export default CertificationViewHeader;
